import script from "./match_page.vue?vue&type=script&setup=true&lang=js"
export * from "./match_page.vue?vue&type=script&setup=true&lang=js"

import "./match_page.vue?vue&type=style&index=0&id=3d2fdd5b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2fdd5b"]])

export default __exports__